/// <reference path="../_references.ts"/>

module App.Questionnaire {

	export class QuestionnaireService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		GetQuestionnaireToken(tokenId: number): ng.IHttpPromise<QuestionnaireToken> {
			return this.$http.get(`${this.Constants.apiUrl}questionnairetoken/${tokenId}`);
		}

		CreateQuestionnaireToken(questionnairetoken: QuestionnaireTokenCreate): ng.IHttpPromise<QuestionnaireToken> {
			return this.$http.post(`${this.Constants.apiUrl}questionnairetoken`, questionnairetoken);
		}

		UpdateQuestionnaireToken(questionnairetoken: QuestionnaireToken): ng.IHttpPromise<QuestionnaireToken> {
			return this.$http.put(`${this.Constants.apiUrl}questionnairetoken/${questionnairetoken.id}`, questionnairetoken);
		}

		SaveQuestionnaireResponse(tokenId: number, response: QuestionnaireResponseCreate): ng.IHttpPromise<QuestionnaireToken> {
			return this.$http.post(`${this.Constants.apiUrl}questionnairetoken/${tokenId}/response`, response);
		}

		EmailQuestionnaire(tokenId: number, data: Object): ng.IHttpPromise<QuestionnaireToken> {
			return this.$http.post(`${this.Constants.apiUrl}questionnairetoken/${tokenId}/email`, data);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new QuestionnaireService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}